import { useState } from 'react';
import { xor } from 'lodash/fp';

export const useToggleListState = (initialValues) => {
    const [values, setValues] = useState(initialValues);
    const toggle = (value) => setValues(xor(values, [value]));

    return [values, toggle, setValues];
};
